/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum InvoiceDataError {
  None = 0,
  ArticleMissing = 1,
  ArticleQuantity = 2,
  MissingConnection = 4,
  WaitingForService = 8,
  MissingPrice = 16,
  RequiresReview = 32,
  MultipleOrNoSource = 64,
  DuplicateMRN = 128,
}
